import * as types from "@/store/mutation-types";
import router from "@/router";
import { connection } from "@/apis";

const state = {
  apis: {
    config: {
      headers: {
        "app-id": "44f51ffe7ee9f76613edb16e3f40d0c7be198ecc",
        "app-secret": "f91ddc6228be355c75d9f1bc63e66d9c78e67f3a"
      },
      url: "https://appconfig.api.unoapp.io"
    }
  },
  businessId: "",
  connections: {},
  environment: "",
  loginUrl: "https://accounts.beta.unoapp.io",
  origin: "",
  token: ""
};

export const getters = {
  loading: state => !!state.connections.loading,
  token: state => state.token,
  businessId: state => state.businessId
};

export const actions = {
  goToLoginUrl({ state }) {
    window.location.href = state.loginUrl;
  },
  async logIn({ commit, dispatch, state }, token) {
    if (!token) {
      dispatch("auth/goToLoginUrl", null, { root: true });
    } else {
      commit(types.SET_TOKEN, token);
      let origin = window.location.hostname.toLowerCase();
      if (origin === "localhost") {
        origin = "faq.staging.unoapp.io";
      }
      commit(types.SET_ORIGIN, origin);

      const environment = (function() {
        if (origin.includes("dev")) return "development";
        if (origin.includes("beta")) return "staging";
        if (origin.includes("staging")) return "staging";
        return "production";
      })();
      commit(types.SET_ENVIRONMENT, environment);

      await connection({
        api: "config",
        failMessage: `Failed to get app settings`,
        method: "GET",
        mutation: `auth/${types.SET_LOADING}`,
        name: "config",
        params: {
          origin: state.origin,
          env: state.environment
        },
        url: `api/v1/appconfig`
      }).then(response => {
        if (response.payload) {
          commit(types.SET_LOGIN_URL, response.payload.loginUrl);
          commit(types.SET_APIS, response.payload.apis);
        } else {
          dispatch(
            "snackbar/add",
            {
              text: `App settings not found`,
              open: true,
              timeout: 0
            },
            { root: true }
          );
        }
      });

      await connection({
        api: "auth",
        failMessage: `Failed during login attempt`,
        method: "POST",
        mutation: `auth/${types.SET_LOADING}`,
        name: "loading",
        url: `authenticate/api/auth/login/verify`
      })
        .then(response => {
          if (
            response &&
            response.payload &&
            response.payload.session &&
            response.payload.session.attributes &&
            response.payload.session.attributes.authorization &&
            response.payload.session.attributes.authorization.business &&
            response.payload.session.attributes.authorization.business.id
          ) {
            commit(
              types.SET_BUSINESS_ID,
              response.payload.session.attributes.authorization.business.id
            );
          } else throw new Error();

          router.push({ name: "Types" });
        })
        .catch(() => {
          dispatch("auth/goToLoginUrl", null, { root: true });
        });
    }
  },
  logOut({ dispatch }) {
    localStorage.removeItem("vuex");
    dispatch("auth/goToLoginUrl", null, { root: true });
  }
};

export const mutations = {
  [types.SET_APIS](state, apis) {
    state.apis = {
      ...state.apis,
      ...apis
    };
  },
  [types.SET_BUSINESS_ID](state, businessId) {
    state.businessId = businessId;
  },
  [types.SET_ENVIRONMENT](state, environment) {
    state.environment = environment;
  },
  [types.SET_LOGIN_URL](state, loginUrl) {
    state.loginUrl = loginUrl;
  },
  [types.SET_LOADING](state, { name, loading }) {
    state.connections = {
      ...state.connections,
      [name]: loading
    };
  },
  [types.SET_ORIGIN](state, origin) {
    state.origin = origin;
  },
  [types.SET_TOKEN](state, token) {
    state.token = token;
  }
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};
